import { useAuth0 } from '@auth0/auth0-react';
import {
    Box,
    Button,
    Checkbox,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { format, parseISO } from 'date-fns';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteAvailability } from '../../redux/AvailabilitySlice';
import SimpleSnackbar from '../SnackBar/SimpleSnackbar';
import sendNotification from '../../utils/sendNotification';

const AvailabilityList = props => {
    const dispatch = useDispatch();
    const [deleteList, setDeleteList] = useState([]);
    const [loading, setLoading] = useState(false);
    const { getAccessTokenSilently } = useAuth0();

    const [snack, setSnack] = useState({
        open: false,
        message: '',
        severiy: 'success',
    });

    const deleteAvail = async () => {
        setLoading(true);
        try {
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            let dynamoData = {
                token: token,
                request: {
                    items: deleteList,
                },
            };

            const outcome = await dispatch(deleteAvailability(dynamoData));
            console.log('edited outcome', outcome.payload.status);
            if (outcome.payload.status === 200) {
                setDeleteList([]);
                // setSnack({
                //     message: 'Deletion successful',
                //     severity: 'success',
                //     open: true,
                // });
                sendNotification('success', 6000, 'Deletion successful');
                // setTimeout(() => {
                //     setSnack({
                //         message: '',
                //         severity: 'success',
                //         open: false,
                //     });
                // }, 6000);
            } else if (outcome.payload.status === 206) {
                setDeleteList([]);
                sendNotification(
                    'warning',
                    6000,
                    'Deletion partially successful'
                );
                // setSnack({
                //     message: 'Deletion partially successful',
                //     severity: 'warning',
                //     open: true,
                // });
                // setTimeout(() => {
                //     setSnack({
                //         message: '',
                //         severity: 'warning',
                //         open: false,
                //     });
                // }, 6000);
            } else {
                // setSnack({
                //     message: 'Cannot delete availability',
                //     severity: 'error',
                //     open: true,
                // });
                // setTimeout(() => {
                //     setSnack({
                //         message: '',
                //         severity: 'error',
                //         open: false,
                //     });
                // }, 6000);
                sendNotification('error', 6000, 'Cannot delete availability');
            }
            setLoading(false);
        } catch (err) {
            console.log('Error occurred deleting availability');

            sendNotification('error', 6000, 'Cannot delete availability');
            // setSnack({
            //     message: 'Cannot delete availability',
            //     severity: 'error',
            //     open: true,
            // });
            // setTimeout(() => {
            //     setSnack({
            //         message: '',
            //         severity: 'error',
            //         open: false,
            //     });
            // }, 6000);
        }
    };

    const handleCheck = event => {
        console.log('event', event.target.checked, event.target.id);
        if (event.target.checked) {
            setDeleteList([...deleteList, event.target.id]);
        } else if (event.target.checked === false) {
            let tempList = [...deleteList];
            let findIndex = tempList.indexOf(event.target.id);

            if (findIndex !== -1) {
                tempList.splice(findIndex, 1);
            }
            console.log('newIndex', tempList);
            setDeleteList(tempList);
        }
    };

    return (
        <Box sx={{ paddingBottom: '80px' }}>
            <TableContainer component={Paper}>
                <Table
                    sx={{
                        minWidth: 300,
                        margin: 'auto',
                        padding: '20px',
                    }}
                    size="small"
                    aria-label="a dense table"
                    data-cy="avail-table"
                >
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">
                                Select
                                {/* <Checkbox /> */}
                            </TableCell>
                            <TableCell align="center">Date</TableCell>
                            <TableCell align="center">Start Time</TableCell>
                            <TableCell align="center">End Time</TableCell>
                            <TableCell align="center">Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.list
                            .filter(row => new Date(row.startDate) > new Date())
                            .map(row => (
                                <TableRow
                                    key={row.startDate}
                                    hover
                                    selected={
                                        row.status === 'On Hold' ? true : false
                                    }
                                >
                                    <TableCell
                                        align="center"
                                        component="th"
                                        scope="row"
                                    >
                                        <Checkbox
                                            disabled={
                                                row.status !== 'Available'
                                            }
                                            onClick={handleCheck}
                                            id={row.pk1 + '|' + row.sk1}
                                            data-cy="select"
                                        />
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        component="th"
                                        scope="row"
                                    >
                                        {format(
                                            parseISO(row.startDate),
                                            'dd/MMM/yyyy'
                                        )}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.status === 'Confirmed' &&
                                        typeof row.bookingStartDate !==
                                            'undefined'
                                            ? format(
                                                  parseISO(
                                                      row.bookingStartDate
                                                  ),
                                                  'HH:mm'
                                              )
                                            : format(
                                                  parseISO(row.startDate),
                                                  'HH:mm'
                                              )}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.status === 'Confirmed' &&
                                        typeof row.bookingEndDate !==
                                            'undefined'
                                            ? format(
                                                  parseISO(row.bookingEndDate),
                                                  'HH:mm'
                                              )
                                            : format(
                                                  parseISO(row.endDate),
                                                  'HH:mm'
                                              )}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.status}
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <LoadingButton
                sx={{ m: 1 }}
                onClick={deleteAvail}
                variant="outlined"
                disabled={deleteList.length === 0}
                data-cy="table-delete"
                loading={loading}
            >
                Delete
            </LoadingButton>
            <SimpleSnackbar
                message={snack.message}
                open={snack.open}
                severity={snack.severity}
            />
        </Box>
    );
};

export default AvailabilityList;
